import { useAuth } from "./AuthContext";

export const RoleGuard = ({ roles, children }: { roles: string[]; children: JSX.Element }) => {
  const { user } = useAuth();
  if (!user || !roles.includes(user.role)) return null;
  return children;
}; 